import React, { Component } from 'react'
// import Wallpaper from '../Components/Wallpaper'

class Footer extends Component {

    render(){
        return (
            <section id="footer">
                {/* <Wallpaper/>  */}
                <div className="copy">
                    <div className="line"></div>
                    &copy; copyright 2020 | made with 🖤  by mary kang 
                </div>
            </section>
        )
    }
}

export default Footer